import { Icon } from '@/components/icons/svg-icons';
import { BetSettingModal } from '@/features/profile/profile-panel/components/bet-setting-modal';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { betSettingStyle } from './bet-setting.style';
import { KafkaNote } from '@nf/utils-common/constants';
import { useAppearanceStore } from '@/store/appearance';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { ViewEnum } from '@/types';

export const BetSetting = ({ className }:{className?: string}) => {
	const t = useTranslations('General');
	const [openBetSettingModal, setOpenBetSettingModal] = useState(false);
	const view = useAppearanceStore(state => state.view);

	const openBetSetting = () => {
		setOpenBetSettingModal(true);

		const kafkaData = view === ViewEnum.galaxy ? {
			note: KafkaNote.GalaxyV2,
			type: 8,
			action: 2
		} : {
			note: KafkaNote.MarsV1,
			type: 10,
			action: 10
		};
		
		setKafkaNormal(kafkaData);
	}

	return (
		<>
			<div className={clsx(className, betSettingStyle.textContent)}>
				<div className={betSettingStyle.button} onClick={openBetSetting}>
					<Icon className={betSettingStyle.icon} name={'gear-setting'} />
					<span className="checkbox__text">{t('lbl_BetSetting')}</span>
				</div>
				
			</div>
			<BetSettingModal isOpen={openBetSettingModal} closeModal={() => setOpenBetSettingModal(false)} />
		</>
	
	)
}